import { ExportButtonGraphql } from "components/actions/ExportButtonGraphql";
import { EventDataTypes } from "lib/tracking";
import { useBidExport } from "../../lib/hooks/api/bid/bids/useBidExport";
import { BidFilters, convertBidFiltersToSearchRequest } from "./utils";

export default function ExportBidsButton({
  filters,
  totalCount,
  isLoading,
  selectedBids,
}: {
  filters: BidFilters;
  totalCount?: number;
  isLoading?: boolean;
  selectedBids?: string[];
}) {
  const bidExportMutation = useBidExport();

  const totalResults: number =
    selectedBids && selectedBids.length > 0 ? selectedBids.length : totalCount || 0;

  return (
    <ExportButtonGraphql
      isLoadingTotalResults={isLoading ?? false}
      totalResults={totalResults}
      exportMutation={bidExportMutation}
      exportVariables={{
        filters: convertBidFiltersToSearchRequest(filters),
        pagination: {
          pageSize: totalResults + 1,
          page: 1,
        },
        selectedBids: { bidIds: selectedBids },
      }}
      exportDataType={EventDataTypes.bids}
    />
  );
}
